exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-csp-tsx": () => import("./../../../src/pages/csp.tsx" /* webpackChunkName: "component---src-pages-csp-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-our-house-tsx": () => import("./../../../src/pages/our-house.tsx" /* webpackChunkName: "component---src-pages-our-house-tsx" */),
  "component---src-pages-wheel-tsx": () => import("./../../../src/pages/wheel.tsx" /* webpackChunkName: "component---src-pages-wheel-tsx" */)
}

